import ClientSuspense from '@components/ClientSuspense'
import {useEffect} from 'react'
import useLazyAnalyticsV2 from '../hooks/useLazyAnalyticsV2'
import {INTERNAL_EVENTS} from '../types/analyticsServicesTypes'

export interface TrackUpsellingViewProps {
  products: any
}

function TrackUpsellingViewInner(props: TrackUpsellingViewProps) {
  const {products} = props
  const analyticsV2 = useLazyAnalyticsV2()
  useEffect(() => {
    if (!products) return
    analyticsV2.trackEventAsDefaultOnInternal(INTERNAL_EVENTS.upsellingViewed, {
      itemsAmount: products.length,
      productsIds: products.length ? products.map(p => p._id).join(',') : null,
    })
  }, [])
  return null
}

export default function TrackUpsellingView(props: Readonly<TrackUpsellingViewProps>) {
  return (
    <ClientSuspense fallback={null}>
      <TrackUpsellingViewInner {...props} />
    </ClientSuspense>
  )
}
